<template>
  <navigation-menu-item
    v-if="showBalanceMoney"
    title="השקעה לטווח קצר"
    target-path="balance-money"
    v-on:navigate="$emit('navigate')"/>
</template>

<script>
import CustomerBenefits from '@/mixins/CustomerBenefits';
import NavigationMenuItem from '@/base-components/app-header/NavigationMenuItem';

export default {
  name: 'BalanceMoneyMenuItem',
  components: {
    NavigationMenuItem,
  },
  mixins: [CustomerBenefits],
  computed: {
    showBalanceMoney() {
      return !this.promotionByHarel;
    },
  },
};
</script>

<style scoped lang="scss">
</style>
